import { useEffect, useState } from 'react'
import { Helmet } from 'react-helmet-async'
import {
  Container,
  Stack,
  Card,
  Typography,
  Box,
  CircularProgress
} from '@mui/material'

import { getCompanyIntegration } from 'services/requests/companyIntegration'
import { toast } from 'utils'

import CompanyIntegrationForm from 'sections/settings/CompanyIntegrationForm'

export default function CompanyIntegration() {
  const [loading, setLoading] = useState(true)
  const [defaultValues, setDefaultValues] = useState(null)

  const getData = () => {
    setLoading(true)
    getCompanyIntegration()
      .then((res) => {
        setDefaultValues(res)
      })
      .catch((err) => {
        toast(err, 'error')
      })
      .finally(() => {
        setLoading(false)
      })
  }

  useEffect(() => {
    getData()
  }, [])

  const handleSuccess = () => {
    getData()
  }

  return (
    <>
      <Helmet>
        <title>Integrações | CredPah</title>
      </Helmet>

      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4">Integrações</Typography>
        </Stack>

        <Card sx={{ p: 3 }}>
          {loading ? (
            <Box sx={{ display: 'flex', justifyContent: 'center', py: 8 }}>
              <CircularProgress />
            </Box>
          ) : (
            <CompanyIntegrationForm
              defaultValues={defaultValues}
              onSuccess={handleSuccess}
            />
          )}
        </Card>
      </Container>
    </>
  )
}
